import Vue from "vue";
import Vuex from "vuex";
import axios from "axios"
import config from "./config"
import error from "./error"

Vue.use(Vuex);

var setFormData = function (data) {
  var params = new URLSearchParams();
  for (var key in data) {
    if (data[key] !== null && data[key] !== undefined) {
      params.append(key, data[key]);
    }
  }
  return params;
}
var formData = function (data) {
  var params = new FormData();
  for (var key in data) {
    if (data[key] !== null && data[key] !== undefined) {
      params.append(key, data[key]);
    }
  }
  return params;
}
export default new Vuex.Store({
  state: {
    userInfo: JSON.parse(sessionStorage.getItem("userInfo")) || {},
    pageTitle: 'login',
    edit: false,
    warning: {
      warningMsg: "",
      warningFalg: false,
      button: []
    },
    magazine: {
      magazineFalg: false,
      id: "",
      rnd: "",
      editorial: {
        langMap: []
      }
    },
    groupObj: {
      groupFalg: false,
      obj: {},
      button: [],
      index: "",
      objType: "",
    },
    moduleObj: {
      groupFalg: false,
      obj: {},
      button: [],
      index: "",
      objType: "",
    },
    eventListObj: {
      groupFalg: false,
      button: [],
    },
    poiListObj: {
      groupFalg: false,
      button: [],
    },
    eventGroupListObj: {
      groupFalg: false,
      button: [],
    },
    ordereventListObj: {
      groupFalg: false,
      button: [],
    },
    orderpromotionListObj: {
      groupFalg: false,
      button: [],
    },
    orderSocialMediaListObj: {
      groupFalg: false,
      button: [],
    },
    orderdailyeventListObj: {
      groupFalg: false,
      button: [],
    }
  },
  mutations: {
    setPageTitle(state, string) {
      state.pageTitle = string;
    },
    setwarning(state, data) {
      state.warning.warningMsg = data.string;
      state.warning.warningFalg = data.boolean;
      state.warning.button = data.button;
    },
    setmagazine(state, data) {
      state.magazine.magazineFalg = data.boolean;
      state.magazine.editorial = data.editorial;
      state.magazine.rnd = data.rnd;
      // state.magazine.type = data.type;
      // state.magazine.image = data.image;
      // state.magazine.cardTitle = data.cardTitle;
      // state.magazine.editorialTitle = data.editorialTitle;
    },
    setgroup(state, data) {
      state.groupObj.obj = data.obj;
      state.groupObj.objType = data.objType;
      state.groupObj.altText = data.altText;
      state.groupObj.index = data.index;
      state.groupObj.groupFalg = data.boolean;
      state.groupObj.callback = data.callback;
    },
    setmodule(state, data) {
      state.moduleObj.obj = data.obj;
      state.moduleObj.objType = data.objType;
      state.moduleObj.index = data.index;
      state.moduleObj.groupFalg = data.boolean;
      state.moduleObj.callback = data.callback;
    },
    seteventlist(state, data) {
      state.eventListObj.groupFalg = data.boolean;
      state.eventListObj.callback = data.callback;
      state.eventListObj.button = data.button;
      state.eventListObj.id = data.id;
      state.eventListObj.both = data.both;
      state.eventListObj.single = data.single;
    },
    setpoilist(state, data) {
      state.poiListObj.groupFalg = data.boolean;
      state.poiListObj.callback = data.callback;
      state.poiListObj.source = data.source;
      state.poiListObj.button = data.button;
    },
    seteventgrouplist(state, data) {
      state.eventGroupListObj.groupFalg = data.boolean;
      state.eventGroupListObj.callback = data.callback;
      state.eventGroupListObj.button = data.button;
    },
    setordereventlist(state, data) {
      state.ordereventListObj.groupFalg = data.boolean;
      state.ordereventListObj.callback = data.callback;
      state.ordereventListObj.button = data.button;
    },
    setorderpromotionlist(state, data) {
      state.orderpromotionListObj.groupFalg = data.boolean;
      state.orderpromotionListObj.callback = data.callback;
      state.orderpromotionListObj.button = data.button;
    },
    setordersocialmedialist(state, data) {
      state.orderSocialMediaListObj.groupFalg = data.boolean;
      state.orderSocialMediaListObj.callback = data.callback;
      state.orderSocialMediaListObj.button = data.button;
    },
    setorderdailyeventlist(state, data) {
      state.orderdailyeventListObj.groupFalg = data.boolean;
      state.orderdailyeventListObj.callback = data.callback;
      state.orderdailyeventListObj.button = data.button;
    },
    login(state, userInfo) {
      Vue.set(state, 'userInfo', userInfo);
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
    }
  },
  getters: {
    warning: state => state.warning,
  },
  actions: {
    async login(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/login`, data);
          if (result.data.errorCode === 0) {
            let assembleFunction = function (parentObj, list) {
              for (var i = 0; i < list.length; i++) {
                var childObj = list[i];
                if (parentObj.id == childObj.parentId) {
                  if (parentObj.children) {
                    parentObj.children.push(childObj);
                  } else {
                    parentObj.children = [];
                    parentObj.children.push(childObj);
                  }
                  assembleFunction(childObj, list);
                }
              }
            }
            let systemFuncs = result.data.result.systemFuncs;
            var rootObj = { id: 0 };
            assembleFunction(rootObj, systemFuncs);
            result.data.result.systemFuncs = rootObj.children;
            result.data.result.langCode = "en_US";
            result.data.result.loginType = 1;
            context.commit("login", result.data.result);
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () { }
              }]
            })
            resolve(false)
          }
        } catch (err) {
          console.log(err, "错误")
          reject(err)
        }
      })
    },
    async apiEvent(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          var url = data.apiUrl;
          delete data['apiUrl']
          let result = await axios.post(`${config.domain}` + url, setFormData(data))

          if (!result.data.errorCode || result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () { context.commit("setwarning", { string: "", boolean: false }); }
              }]
            })
            resolve(false)
          }
        }
        catch (err) {

          reject(err)
        }
      })
    },
    async apiEventFromData(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          var url = data.apiUrl;
          delete data['apiUrl'];
          debugger
          var domain = `${config.domain}`
          let result = await axios.post(domain + url, formData(data))
          console.log(result)
          if (result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {
                  context.commit("setwarning", { string: "", boolean: false });
                }
              }]
            })
          }
        }
        catch (err) {

          reject(err)
        }
      })
    },
    async apiGetFileEvent(context, data) {
      return new Promise(async (resolve, reject) => {
        var url = data.apiUrl;
        delete data['apiUrl'];

        var domain = `${config.domain}`
        if (data.apiDomain) {
          domain = data.apiDomain;
          delete data['apiDomain'];
        }

        delete data['accessToken'];
        let result = await axios.post(domain + url, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        console.log(result)
        if (!result.data.errorCode) {
          resolve(result)
        } else {
          context.commit("timeout", result.data);
          context.commit("setwarning", {
            string: result.data.message,
            boolean: true,
            button: [{
              name: "Cancel",
              callBack: function () {
                context.commit("setwarning", { string: "", boolean: false });
              }
            }]
          })

        }
      })
    },
  },
  modules: {
  }
});
